import { createStore } from "vuex";
import VueCookies from "vue-cookies";

export default createStore({
  state: {
    roleLevel: 1,
    isLogin:
      VueCookies.get("tokenWeb") && VueCookies.get("userInfo") ? true : false, //用户是否登录
  },
  mutations: {
    setRoleLevel(state, roleLevel) {
      state.roleLevel = roleLevel;
    },
    //设置登录状态
    setLoginStatus(state, payload) {
      state.isLogin = payload.status;
    },
  },
  actions: {},
  modules: {},
});
